import React from 'react';
import { Icon, Box } from '@spothero/ui';
import { useMobileWebRelevanceVariation } from 'hooks/use-mobile-web-relevance-variation';
import { useMobileViewToggle } from 'pages/search/components/search-component/mobile-view-toggle/hooks/use-mobile-view-toggle';
import { FilterButtonBase } from '../filter-bases';
export const FilterMobileViewToggle = () => {
    const { isVariation2 } = useMobileWebRelevanceVariation();
    const { handleClick, activeOption } = useMobileViewToggle();
    const { label, IconOption } = activeOption;
    return isVariation2 ? (<FilterButtonBase key={label} onClick={handleClick} testid="QuickFilters-filter-map">
            <Icon as={IconOption} height="4.5" width="4.5"/>
            <Box>{label}</Box>
        </FilterButtonBase>) : null;
};
